import { useEffect } from 'react';

function ensureMeta(attr, key, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

// Sets document title, description, canonical, and Open Graph tags for SPA routes.
export default function usePageMeta(title, description) {
  useEffect(() => {
    const fullTitle = !title
      ? 'Tactmark | Post-Match Coaching Intelligence for Football'
      : title.includes('|') || title.startsWith('Tactmark')
        ? title
        : `${title} | Tactmark`;
    document.title = fullTitle;

    if (description) {
      ensureMeta('name', 'description', description);
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const href = `https://tactmark.com${window.location.pathname}`;
    canonical.setAttribute('href', href);

    ensureMeta('property', 'og:title', fullTitle);
    ensureMeta('property', 'og:description', description || '');
    ensureMeta('property', 'og:url', href);
    ensureMeta('property', 'og:type', 'website');
    ensureMeta('name', 'twitter:title', fullTitle);
    ensureMeta('name', 'twitter:description', description || '');
  }, [title, description]);
}
